// import React from 'react';
// import './HongInput.scss';

// const HongInput = ({ 
//   value, 
//   onChange, 
//   className, 
//   placeholder, 
//   isNumber = false, 
//   spellCheck = false, 
//   autoComplete = 'off',
//   readOnly = false // ✅ 추가
// }) => {

//   const handleInputChange = (e) => {
//     const inputValue = e.target.value;

//     if (readOnly) return; // ✅ 읽기 전용이면 변경 무시

//     if (isNumber) { 
//       if (/^\d*$/.test(inputValue)) {
//         onChange(e);
//       }
//     } else {
//       onChange(e);
//     }
//   };

//   return (
//     <input
//       type="text"
//       className={`hong-input ${className}`}
//       value={value}
//       onChange={handleInputChange}
//       placeholder={placeholder}
//       spellCheck={spellCheck}
//       autoComplete={autoComplete}
//       readOnly={readOnly} // ✅ 적용
//     />
//   );
// };

// export default HongInput;


import React from 'react';
import './HongInput.scss';

// isNegative추가: 음수 허용 옵션
const HongInput = ({ 
  value, 
  onChange, 
  className = '',
  placeholder, 
  isNumber = false,
  isNegative = false,   // ✅ 음수 허용 옵션 추가
  useComma = false,
  spellCheck = false, 
  autoComplete = 'off',
  readOnly = false,
  ...rest  // ✅ 나머지 props 받기 (onKeyDown, onKeyUp, onBlur 등)
}) => {

  const formatNumberWithComma = (input) => {
    if (input === null || input === undefined) return '';
    const str = String(input);
    if (str === '') return '';

    const isMinus = str.startsWith('-');
    const digits = str.replace(/[^\d]/g, '');
    if (!digits) return isMinus ? '-' : '';

    const formatted = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return isMinus ? `-${formatted}` : formatted;
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    if (readOnly) return;

    if (isNumber) {
      const normalizedValue = useComma ? inputValue.replace(/,/g, '') : inputValue;

      // ✅ 음수 허용 여부에 따라 정규식 분기
      const regex = isNegative
        ? /^-?\d*$/
        : /^\d*$/;

      if (regex.test(normalizedValue)) {
        if (useComma) {
          const nextEvent = {
            ...e,
            target: {
              ...e.target,
              value: normalizedValue,
            },
          };
          onChange(nextEvent);
          return;
        }
        onChange(e);
      }
    } else {
      onChange(e);
    }
  };

  const displayValue = isNumber && useComma
    ? formatNumberWithComma(value)
    : value;

  return (
    <input
      type="text"
      className={`hong-input ${className}`}
      value={displayValue}
      onChange={handleInputChange}
      placeholder={placeholder}
      spellCheck={spellCheck}
      autoComplete={autoComplete}
      readOnly={readOnly}
      {...rest}  // ✅ 나머지 props 전달
    />
  );
};

export default HongInput;
